import { Component, inject, Input, signal } from '@angular/core';
import { CreatorResponseDto } from '../../../../common/general-types/creators.dto';
import { VideoResponseDto } from '../../../../common/general-types/videos.dto';
import { VideoFormatEnum } from '../../../../common/general-types/briefs.dto';
import { FormatService } from '../../../../common/format/format.service';
import { MagicSearchService } from '../../../creators/service/magic-search/magic-search.service';
import { CreatorColumnGenericComponent } from '../../../creators/molecules/creator-column-generic/creator-column-generic.component';
import { VideoThumbnailComponent } from '../../../../atoms/video-thumbnail/video-thumbnail.component';

export interface PinkCreatorCardVideo {
  creator: CreatorResponseDto;
  type: "summary_v1" | "match";
}

@Component({
  selector: 'cv2-creator-card-pink',
  standalone: true,
  imports: [CreatorColumnGenericComponent, VideoThumbnailComponent],
  templateUrl: './creator-card-pink.component.html',
  styleUrl: './creator-card-pink.component.css'
})
export class CreatorCardPinkComponent {

  @Input() creator!: CreatorResponseDto;

  VideoFormatEnum = VideoFormatEnum;
  previewVideo = signal<VideoResponseDto | undefined>(undefined);

  /** Services */
  public magicSearchService = inject(MagicSearchService);
  public formatService = inject(FormatService);
  /** Services - END */

  videoPreview(video: {score: number, video_file: { s3_url: string, cover: string, s3_bucket: string, s3_key: string }}) {

    let typed_Video: VideoResponseDto = {
      id: "",
      key: video.video_file.s3_key,
      status: 0,
      thumbnail: video.video_file.cover,
      ugcBriefApplicationId: null,
      videoFormat: 0,
      videoLength: 0,
      videoName: "",
      briefApplicationId: "",
      thumbnailURL: video.video_file.cover,
      thumbnailCdnKey: video.video_file.s3_key,
      createdDate: new Date(),
      creator: this.creator,
      creatorId: this.creator.blazeFirebaseUid || "",
      fullUrl: video.video_file.s3_url,
    }

    // this.previewVideo = typed_Video;
    this.magicSearchService.previewVideo.set(typed_Video);
    
  }
}
